const KEY = 'thspian.ugcRecentSearches';
const MAX = 6;

export function readUgcRecentSearches(): string[] {
    try {
        const raw = localStorage.getItem(KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(parsed)) return [];
        return parsed
            .filter((item): item is string => typeof item === 'string' && item.trim().length > 0)
            .slice(0, MAX);
    } catch {
        return [];
    }
}

export function rememberUgcSearch(term: string): string[] {
    const clean = term.trim();
    if (clean.length < 4) return readUgcRecentSearches();
    const next = [clean, ...readUgcRecentSearches().filter(item => item.toLowerCase() !== clean.toLowerCase())].slice(
        0,
        MAX,
    );
    localStorage.setItem(KEY, JSON.stringify(next));
    return next;
}
